import React from "react";

const RecentStartToolTip = () => {
  return (
    <div className="bg-white p-6 flex flex-col max-w-[464px] ">
      <p className="text-teal-300 text-left text-body-sm font-normal">
        <b>Recent Start Medications</b> will be part of a "Clinical Analysis" to
        assess for possible Drug Induced Allergic Rhinitis.
      </p>
    </div>
  );
};

export default RecentStartToolTip;
